module.exports = __webpack_public_path__ + "static/Team3-80ba914074ac6e4e2cb25c08d3dc29ad.png";